var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.display),function(t,i){return _c('vs-chip',{key:i},[_c('i',[_vm._v(_vm._s(t.value))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }